import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class VersionsService {
  constructor(private http: HttpClientService) {}

  public createVersion(data): Observable<any> {
    return this.http.post("/api/versiones", data).pipe(tap((_) => console.log("VersionsService.createVersion: Ok.")));
  }
  public getVersion(id: number): Observable<any> {
    return this.http.get(`/api/versiones/${id}`).pipe(tap((_) => console.log("VersionsService.getVersion: Ok.")));
  }
  public getVersions({ query, page, perPage }): Observable<any> {
    const params = {
      query,
      page: page?.toString(),
      per_page: perPage?.toString(),
    };
    return this.http
      .get("/api/versiones/all", { params })
      .pipe(tap(() => console.debug("VersionsService.getVersions: Ok.")));
  }

  public updateVersion(data): Observable<any> {
    return this.http
      .put(`/api/versiones/${data.id}`, data)
      .pipe(tap((_) => console.log("VersionsService.updateVersion: Ok.")));
  }

  public deleteVersion(id): Observable<any> {
    return this.http.delete(`/api/versiones/${id}`).pipe(tap((_) => console.log("VersionsService.deleteVersion: Ok.")));
  }

  public bulkCreateVersions(data): Observable<any> {
    return this.http
      .post("/api/versiones/bulk_create", data)
      .pipe(tap((_) => console.log("VersionsService.bulkCreateVersions: Ok.")));
  }
}
